import qq from "../lib/fileuploader";

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button" ]

  connect() {
    const uploader = new qq.FileUploaderBasic({
      button: (this.hasButtonTarget ? this.buttonTarget : this.element),
      action: this.data.get("url"),
      multiple: false,
      debug: false,
      method: this.httpMetohd,
      params: {
        authenticity_token: document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
      },
      onSubmit: this.onSubmit,
      onComplete: this.onComplete
    })
  }

  onSubmit() {
    // implementar onSubmit na subclasse
  }

  onComplete(id, fileName, response) {
    // implementar onComplete na subclasse
  }

  get httpMetohd() { return 'POST' }

}
